(() => {
  const initFacets = () => {
    const multiSelectToggles = document.querySelectorAll(
      ".multi-select-toggle"
    );
    const booleanFilters = document.querySelectorAll(
      '.toggle-facet input[type="checkbox"]'
    );
    const searchInputs = document.querySelectorAll(
      ".filter-group__search-input"
    );

    const closeAllDropdowns = () => {
      const openToggles = document.querySelectorAll(
        '.multi-select-toggle[aria-expanded="true"]'
      );

      openToggles.forEach((openToggle) => {
        openToggle.setAttribute("aria-expanded", "false");
        const openDropdown = openToggle
          .closest(".multi-select-container")
          .querySelector(".multi-select-dropdown");
        openDropdown.style.display = "none";
      });
    };

    const closeDropdownsExcept = (exceptToggle) => {
      const openToggles = document.querySelectorAll(
        '.multi-select-toggle[aria-expanded="true"]'
      );

      openToggles.forEach((openToggle) => {
        if (openToggle !== exceptToggle) {
          openToggle.setAttribute("aria-expanded", "false");
          const openDropdown = openToggle
            .closest(".multi-select-container")
            .querySelector(".multi-select-dropdown");
          openDropdown.style.display = "none";
        }
      });
    };

    const handleToggleClick = (event) => {
      const toggle = event.currentTarget;
      const container = toggle.closest(".multi-select-container");
      const dropdown = container.querySelector(".multi-select-dropdown");
      const isExpanded = toggle.getAttribute("aria-expanded") === "true";

      // Close all other dropdowns first
      closeDropdownsExcept(toggle);

      // Toggle current dropdown
      const newState = !isExpanded;
      toggle.setAttribute("aria-expanded", newState);
      dropdown.style.display = newState ? "block" : "none";
    };

    const handleOutsideClick = (event) => {
      if (!event.target.closest(".multi-select-container")) {
        closeAllDropdowns();
      }
    };

    const handleBooleanFilter = (event) => {
      const checkbox = event.currentTarget;
      const paramName = checkbox.id;
      const currentUrl = new URL(window.location.href);
      const searchParams = currentUrl.searchParams;

      if (checkbox.checked) {
        searchParams.set(paramName, "1");
      } else {
        searchParams.delete(paramName);
      }

      window.location.href = currentUrl.toString();
    };

    const handleSearch = (event) => {
      try {
        if (!event || !event.target) {
          console.error("Invalid event object in handleSearch");
          return;
        }

        const searchInput = event.target;
        const searchTerm = searchInput.value.toLowerCase();
        const filterGroup = searchInput.closest(".multi-select-container");

        if (!filterGroup) {
          console.error("Could not find parent filter group container");
          return;
        }

        const filterItems = filterGroup.querySelectorAll(
          ".multi-select-option"
        );
        if (!filterItems.length) {
          console.warn("No filter items found to search through");
          return;
        }

        filterItems.forEach((item) => {
          try {
            const label = item.querySelector("label");
            if (!label) {
              console.warn("Filter item missing label element");
              return;
            }

            const labelText = label.textContent.toLowerCase();
            item.style.display = labelText.includes(searchTerm) ? "" : "none";
          } catch (itemError) {
            console.error("Error processing filter item:", itemError);
          }
        });
      } catch (error) {
        console.error("Error in handleSearch:", error);
      }
    };

    // Add click event listeners to all toggles
    multiSelectToggles.forEach((toggle) => {
      toggle.addEventListener("click", handleToggleClick);
    });

    // Add change event listeners to boolean filters
    booleanFilters.forEach((filter) => {
      filter.addEventListener("change", handleBooleanFilter);
    });

    // Add input event listeners to search inputs
    searchInputs.forEach((input) => {
      input.addEventListener("input", handleSearch);
    });

    // Close dropdowns when clicking outside
    document.addEventListener("click", handleOutsideClick);
  };

  // Initialize on DOM ready
  const initialize = () => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        initFacets();
        checkFiltersOverflow();
      });
    } else {
      initFacets();
      checkFiltersOverflow();
    }

    // Re-initialize facets after any AJAX content updates
    document.addEventListener("shopify:section:load", () => {
      initFacets();
      checkFiltersOverflow();
    });

    // Check for overflow on window resize
    window.addEventListener("resize", checkFiltersOverflow);
  };

  const checkFiltersOverflow = () => {
    const filtersContainer = document.querySelector(".collection__facets");
    if (!filtersContainer) return;

    const filters = filtersContainer.querySelectorAll(".facet");
    if (!filters.length) return;

    // Remove any existing "All Filters" button
    const existingAllFiltersBtn = filtersContainer.querySelector(
      ".all-filters-button"
    );
    if (existingAllFiltersBtn) {
      existingAllFiltersBtn.remove();
    }

    // Reset any existing overflow handling
    filtersContainer.style.display = "flex";
    filtersContainer.style.flexWrap = "nowrap";
    filters.forEach((filter) => {
      // Check if this is a toggle-facet and ensure it displays as flex
      if (filter.classList.contains("toggle-facet")) {
        filter.style.display = "flex";
      } else {
        filter.style.display = "block";
      }
    });

    // Show only first 3 filters
    filters.forEach((filter, index) => {
      if (index < 3) {
        // Check if this is a toggle-facet and ensure it displays as flex
        if (filter.classList.contains("toggle-facet")) {
          filter.style.display = "flex";
        } else {
          filter.style.display = "block";
        }
      } else {
        filter.style.display = "none";
      }
    });

    // If there are more than 3 filters, show the "All Filters" button
    if (filters.length > 3) {
      const allFiltersBtn = document.createElement("button");
      allFiltersBtn.className = "button all-filters-button";
      allFiltersBtn.style.display = "flex";
      allFiltersBtn.style.alignItems = "center";
      allFiltersBtn.style.gap = "8px";

      const buttonText = document.createElement("span");
      buttonText.textContent = "Alle Filter";

      const filterIcon = document.createElement("span");
      filterIcon.innerHTML = `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.00977 13.125C8.00977 12.9592 8.07561 12.8003 8.19282 12.6831C8.31003 12.5658 8.46901 12.5 8.63477 12.5H12.3848C12.5505 12.5 12.7095 12.5658 12.8267 12.6831C12.9439 12.8003 13.0098 12.9592 13.0098 13.125C13.0098 13.2908 12.9439 13.4497 12.8267 13.5669C12.7095 13.6842 12.5505 13.75 12.3848 13.75H8.63477C8.46901 13.75 8.31003 13.6842 8.19282 13.5669C8.07561 13.4497 8.00977 13.2908 8.00977 13.125ZM5.50977 9.375C5.50977 9.20924 5.57561 9.05027 5.69282 8.93306C5.81003 8.81585 5.96901 8.75 6.13477 8.75H14.8848C15.0505 8.75 15.2095 8.81585 15.3267 8.93306C15.4439 9.05027 15.5098 9.20924 15.5098 9.375C15.5098 9.54076 15.4439 9.69973 15.3267 9.81694C15.2095 9.93415 15.0505 10 14.8848 10H6.13477C5.96901 10 5.81003 9.93415 5.69282 9.81694C5.57561 9.69973 5.50977 9.54076 5.50977 9.375ZM3.00977 5.625C3.00977 5.45924 3.07561 5.30027 3.19282 5.18306C3.31003 5.06585 3.46901 5 3.63477 5H17.3848C17.5505 5 17.7095 5.06585 17.8267 5.18306C17.9439 5.30027 18.0098 5.45924 18.0098 5.625C18.0098 5.79076 17.9439 5.94973 17.8267 6.06694C17.7095 6.18415 17.5505 6.25 17.3848 6.25H3.63477C3.46901 6.25 3.31003 6.18415 3.19282 6.06694C3.07561 5.94973 3.00977 5.79076 3.00977 5.625Z" fill="white"/>
</svg>`;

      allFiltersBtn.appendChild(buttonText);
      allFiltersBtn.appendChild(filterIcon);

      allFiltersBtn.addEventListener("click", () => {
        FilterDrawer.open();
      });

      filtersContainer.appendChild(allFiltersBtn);
    }
  };

  initialize();
})();
